import { gql } from '@apollo/client'

const DELETE_CONTACT = gql`
  mutation DeleteContact($documentNumber: ID!, $value: String!) {
    deleteContact(documentNumber: $documentNumber, value: $value) {
      message
      statusCode
      code
      error
    }
  }
`

export default DELETE_CONTACT
